import type { FC, ReactNode } from 'react'

import {
    createContext,
    useCallback,
    useContext,
    useMemo,
    useState
} from 'react'

interface IntroContextValue {
    done: boolean
    finish: () => void
}

interface IntroProviderProps {
    children: ReactNode
}

const IntroContext = createContext<IntroContextValue>({
    done: true,
    finish: () => undefined
})

export const IntroProvider: FC<IntroProviderProps> = ({ children }): ReactNode => {
    const [done, setDone] = useState(false)

    const finish = useCallback(() => {
        setDone(true)
    }, [])

    const value = useMemo(() => ({ done, finish }), [done, finish])

    return (
        <IntroContext.Provider value={value}>
            {children}
        </IntroContext.Provider>
    )
}

export const useIntro = (): IntroContextValue => {
    return useContext(IntroContext)
}
